module.exports = __webpack_public_path__ + "6020.db3338dbf838ed581682b17432613e61.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6020.png
// module id = 192
// module chunks = 0